import { format, formatInTimeZone, toZonedTime } from 'date-fns-tz';
export function detectTimezone() {
    try {
        const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        if (timeZone && timeZone !== 'UTC') {
            return timeZone;
        }
        const offset = new Date().getTimezoneOffset();
        const offsetHours = Math.abs(offset) / 60;
        const timezoneMap = {
            '0': 'UTC',
            '1': 'Europe/London',
            '2': 'Europe/Paris',
            '3': 'Europe/Moscow',
            '4': 'Asia/Dubai',
            '5': 'Asia/Kolkata',
            '6': 'Asia/Bangkok',
            '7': 'Asia/Ho_Chi_Minh',
            '8': 'Asia/Shanghai',
            '9': 'Asia/Tokyo',
            '10': 'Australia/Sydney',
            '11': 'Pacific/Guadalcanal',
            '12': 'Pacific/Auckland',
            '-5': 'America/New_York',
            '-6': 'America/Chicago',
            '-7': 'America/Denver',
            '-8': 'America/Los_Angeles',
            '-9': 'America/Anchorage',
            '-10': 'Pacific/Honolulu'
        };
        return timezoneMap[offset] || 'UTC';
    }
    catch (error) {
        return 'UTC';
    }
}
export function getCurrentTimezone() {
    const swissTimezone = 'Europe/Zurich';
    localStorage.setItem('APP_TIMEZONE', swissTimezone);
    return swissTimezone;
}
export function formatDate(date, formatStr) {
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return format(dateObj, formatStr);
}
export function formatLocalDate(date, format = 'dd/MM/yyyy - HH:mm') {
    const timezone = getCurrentTimezone();
    const dateObj = typeof date === 'string' ? new Date(date) : date;
    return formatInTimeZone(dateObj, timezone, format);
}
export function convertUtcToLocal(utcDate) {
    const timezone = getCurrentTimezone();
    const dateObj = typeof utcDate === 'string' ? new Date(utcDate) : utcDate;
    return toZonedTime(dateObj, timezone);
}
export function convertLocalToUtc(localDate) {
    const timezone = getCurrentTimezone();
    return new Date(localDate.getTime() - (localDate.getTimezoneOffset() * 60000));
}
export function getCurrentLocalDate() {
    const timezone = getCurrentTimezone();
    return toZonedTime(new Date(), timezone);
}
export function getCurrentLocalDateFormatted(format = 'dd/MM/yyyy - HH:mm') {
    return formatLocalDate(getCurrentLocalDate(), format);
}
export function getCurrentLocalTimeInMinutes() {
    const now = getCurrentLocalDate();
    return now.getHours() * 60 + now.getMinutes();
}
export function isTodayStillValid(maxHour = 21) {
    const currentTime = getCurrentLocalTimeInMinutes();
    return currentTime < maxHour * 60;
}
export function getAvailableDates() {
    const today = getCurrentLocalDate();
    const tomorrow = new Date(today);
    tomorrow.setDate(today.getDate() + 1);
    const dates = [];
    if (isTodayStillValid()) {
        dates.push({
            value: today.toISOString().split('T')[0],
            label: `${today.toLocaleDateString('fr-FR', {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            })} - Aujourd'hui`,
        });
    }
    dates.push({
        value: tomorrow.toISOString().split('T')[0],
        label: `${tomorrow.toLocaleDateString('fr-FR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        })} - Demain`,
    });
    return dates;
}
export function getAvailableTimes(selectedDate, startHour = 11, endHour = 22, interval = 15) {
    const times = [];
    const currentTime = getCurrentLocalTimeInMinutes();
    const today = getCurrentLocalDate().toISOString().split('T')[0];
    for (let hour = startHour; hour < endHour; hour++) {
        for (let minute = 0; minute < 60; minute += interval) {
            const timeString = `${hour.toString().padStart(2, '0')}:${minute.toString().padStart(2, '0')}`;
            const timeInMinutes = hour * 60 + minute;
            if (selectedDate === today) {
                if (timeInMinutes > currentTime + 30) {
                    times.push(timeString);
                }
            }
            else {
                times.push(timeString);
            }
        }
    }
    return times;
}
export function formatDateForPayload(date, time) {
    const dateObj = new Date(date);
    return `${dateObj.getDate().toString().padStart(2, '0')}-${(dateObj.getMonth() + 1).toString().padStart(2, '0')}-${dateObj.getFullYear()} ${time}`;
}
export function initializeTimezone() {
    const timezone = getCurrentTimezone();
    const now = new Date();
    const localTime = formatLocalDate(now, 'dd/MM/yyyy HH:mm:ss');
}
